import { useTranslation } from 'react-i18next'

import formatDefault from '@dentalux/common/date/formatDefault'

import { Form, Clinic } from '@ana/shared'
import { Optins } from '@ana/shared'
import { GlobalStyles } from '@mui/material'
import Typography from '@mui/material/Typography'
import D21Logo from 'components/icons/D21Logo'

import { Tenant } from '../../@types/Patient'

import SummaryScreen from './components/Content'
import * as S from './PrintableSummary.styles'

type Props = {
  values: Partial<Form>
  clinic?: Clinic
  optins?: Optins
  tenant?: Tenant
}

const PrintableSummaryScreen = ({ values, clinic, optins, tenant }: Props) => {
  const { t } = useTranslation()

  return (
    <S.Root>
      <GlobalStyles styles={S.printableMediaStyles()} />

      <S.Header>
        <S.LogoWrapper>
          <D21Logo />
        </S.LogoWrapper>
      </S.Header>

      <S.Content>
        <SummaryScreen
          shouldShowCancellationNotice={tenant?.subscribedForProducts?.includes('CANCELLATION_FEE')}
          optins={optins}
          initialValues={{
            ...values,
            dataProtection: true,
            dataTruthyness: true,
          }}
        />
      </S.Content>

      <S.SignatureBlock>
        <S.DateAndPlaceWrapper>
          <Typography>
            {clinic?.city ? `${clinic.city}, ` : ''} {formatDefault(new Date())}
          </Typography>

          <S.SignatureLine />

          <Typography>{t('place_and_date')}</Typography>
        </S.DateAndPlaceWrapper>

        <S.SignatureWrapper>
          <S.InvisiblePlaceholder>SignaturePlaceholder</S.InvisiblePlaceholder>

          <S.SignatureLine />

          <Typography>{t('signature')}</Typography>
        </S.SignatureWrapper>
      </S.SignatureBlock>
    </S.Root>
  )
}

export default PrintableSummaryScreen
